import { render, staticRenderFns } from "./PrognoseVinculada.vue?vue&type=template&id=b2c42da4&scoped=true"
import script from "./PrognoseVinculada.vue?vue&type=script&lang=js"
export * from "./PrognoseVinculada.vue?vue&type=script&lang=js"
import style0 from "./PrognoseVinculada.vue?vue&type=style&index=0&id=b2c42da4&prod&lang=css"
import style1 from "../../../css/crud.css?vue&type=style&index=1&id=b2c42da4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c42da4",
  null
  
)

export default component.exports